import type { FieldProp } from 'react-typed-form';

export type Props = Readonly<{
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  field: FieldProp<any>;
}>;

export default function FieldCheckbox({ field }: Props) {
  return (
    <input
      type="checkbox"
      checked={!!field.value}
      onChange={() => field.handleValueChange(!field.value)}
    />
  );
}
